import React, { useContext, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Paper, Drawer, Divider, useTheme } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import LogoutIcon from '@mui/icons-material/Logout'
import { ApiDataWrapperContext } from '../contexts/ApiDataWrapper'
import { AuthContext } from '../contexts/Auth'
import LinkWithQuery from '../components/LinkWithQuery'
import Text from '../components/Text'
import { itensDaBarraInferior, itensDaFolhaMais, itemEstaAtivo } from './navItems'

// A barra inferior do celular. É o padrão que o cliente já usa em app de banco:
// as ações principais ficam ao alcance do polegar, sem depender de ele descobrir
// que três linhas no canto escondem um menu.

// Altura reservada para que o conteúdo da página não fique atrás da barra.
export const ALTURA_BARRA_INFERIOR = 64

function Botao({ item, ativo }) {
  const theme = useTheme()
  const Icone = item.icon

  return (
    <div
      className="flex-1 flex flex-col items-center gap-1 py-2"
      style={{ color: ativo ? theme.palette.primary.main : theme.palette.text.secondary }}
    >
      <Icone style={{ fontSize: 22 }} />
      <span className="text-[10px] leading-none" style={{ fontWeight: ativo ? 700 : 400 }}>
        {item.labelCurto}
      </span>
    </div>
  )
}

export default function BottomNav() {
  const theme = useTheme()
  const location = useLocation()
  const { user } = useContext(ApiDataWrapperContext)
  const { logout } = useContext(AuthContext)
  const [folhaAberta, setFolhaAberta] = useState(false)

  const naBarra = itensDaBarraInferior(user)
  const naFolha = itensDaFolhaMais(user)
  const algumDaFolhaEstaAtivo = naFolha.some(item => itemEstaAtivo(item, location.pathname))

  return (
    <>
      <Paper
        square
        elevation={0}
        component="nav"
        aria-label="Navegação principal"
        className="lg:hidden fixed bottom-0 left-0 right-0 z-[900] flex"
        style={{
          borderTop: `1px solid ${theme.palette.divider}`,
          height: ALTURA_BARRA_INFERIOR,
          '--cor-foco': theme.palette.primary.main
        }}
      >
        {naBarra.map(item => {
          const ativo = itemEstaAtivo(item, location.pathname)
          return (
            <LinkWithQuery
              key={item.to}
              to={item.to}
              className="foco-navegacao flex-1 flex"
              style={{ textDecoration: 'none' }}
              aria-current={ativo ? 'page' : undefined}
            >
              <Botao item={item} ativo={ativo} />
            </LinkWithQuery>
          )
        })}

        <button
          className="foco-navegacao flex-1 flex"
          onClick={() => setFolhaAberta(true)}
          aria-expanded={folhaAberta}
          aria-haspopup="menu"
        >
          <Botao
            item={{ labelCurto: 'Mais', icon: MoreHorizIcon }}
            ativo={folhaAberta || algumDaFolhaEstaAtivo}
          />
        </button>
      </Paper>

      <Drawer
        anchor="bottom"
        open={folhaAberta}
        onClose={() => setFolhaAberta(false)}
        slotProps={{
          paper: {
            sx: { borderRadius: '16px 16px 0 0', pb: 2, '--cor-foco': theme.palette.primary.main }
          }
        }}
      >
        <div className="w-full flex justify-center pt-2 pb-1">
          <span
            className="w-[38px] h-[4px] rounded-full"
            style={{ backgroundColor: theme.palette.divider }}
          />
        </div>

        {naFolha.map(item => {
          const Icone = item.icon
          const ativo = itemEstaAtivo(item, location.pathname)
          return (
            <LinkWithQuery
              key={item.to}
              to={item.to}
              className="foco-navegacao block"
              style={{ textDecoration: 'none' }}
              onClick={() => setFolhaAberta(false)}
              aria-current={ativo ? 'page' : undefined}
            >
              <div
                className="flex items-center gap-3 px-5 py-3"
                style={{ color: ativo ? theme.palette.primary.main : theme.palette.text.primary }}
              >
                <Icone style={{ fontSize: 20, opacity: ativo ? 1 : 0.7 }} />
                <Text className="text-sm" style={{ fontWeight: ativo ? 700 : 500 }}>
                  {item.label}
                </Text>
                {item.badge && (
                  <span
                    className="font-black text-[10px]"
                    style={{ color: theme.palette.primary.main }}
                  >
                    {item.badge}
                  </span>
                )}
              </div>
            </LinkWithQuery>
          )
        })}

        <Divider className="my-1" />

        <button
          className="foco-navegacao w-full flex items-center gap-3 px-5 py-3"
          onClick={() => { setFolhaAberta(false); logout() }}
        >
          <LogoutIcon style={{ fontSize: 20, opacity: 0.7 }} />
          <Text className="text-sm font-medium">Sair da conta</Text>
        </button>
      </Drawer>
    </>
  )
}
